<script lang="ts" setup>
defineProps({
  categoryId: {
    type: String,
    required: false,
  },
  isCraftable: {
    type: Boolean,
    required: false
  },
});

const { trackEvent } = useGAnalytics();
const appStateStore = useAppStateStore();
const isHovered = ref(false);
</script>

<template>
  <NuxtLinkLocale
    :to="`/${isCraftable ? 'craft' : 'store'}/${useRoute().params.merchant}/category/${categoryId}`"
    :data-test="`link-store-see-more-${categoryId}`"
    @click="
      trackEvent(`click_see_more_${$route.name as string}`, {
        category: categoryId,
      })
    "
    class="flex flex-col cursor-pointer">
    <div
      class="flex-1 gradient relative border rounded-lg border-primary-900 will-change-transform overflow-hidden transition ease-in-out duration-300 bg-secondary-900 flex flex-col items-center justify-center"
      :class="
        isHovered ? '-translate-y-1 text-primary-500' : 'text-secondary-200'
      "
      @mouseover="isHovered = true"
      @mouseleave="isHovered = false">
      <BaseIcon name="visibility" class="w-14 h-14 mb-1" />
      <p class="text-lg font-bold text-center px-10">
        {{ $t("main.storeMain.seeMore") }}
        {{
          categoryId
            ? $t(
                `${appStateStore.currentMerchant}.property.categoryId.values.${isCraftable ? 'CRAFT-' : ''}${categoryId}`,
                0
              )
            : ""
        }}
      </p>
    </div>
    <CardStack v-model:is-hovered="isHovered" />
  </NuxtLinkLocale>
</template>

<style scoped>
.gradient {
  background: radial-gradient(
    90% 96.97% at 50% 50%,
    #434343f5 0%,
    #0c0c0c 71.92%
  );
}
</style>
